<template>
  <modal
    name="plateValidationModal"
    :width="'800px'"
    :height="'auto'"
    :scrollable="true"
    :adaptive="true"
    :transition="''"
    :class="'validationsModal'"
  >
    <div class="validation-wrapper">

      <h3 class="title">
        {{$t('ver_validacoes')}}
      </h3>

      <div v-if="validations.length === 0" class="no-validations">
        {{$t('sem_validacoes')}}
      </div>

      <ul v-else class="validation-list">
        <li v-for="(val, index) in validations" :key="index">
          <i class="fas fa-exclamation-triangle warning-icon"></i>
          {{ val }}
        </li>
      </ul>

      <div class="button-row">
        <button class="button ghost" @click="$modal.hide('plateValidationModal')">
          <i class="fas fa-times"></i> {{$t('Fechar')}}
        </button>
      </div>

    </div>
  </modal>
</template>
<script>
import { t } from 'i18next';
export default {
  name: "PlateValidationModal",
  props: {
    validations: {
      type: Array,
      default: () => []
    },
  }
};
</script>

<style scoped lang="less">
@import (reference) url("../../../assets/variables.less");

.validationsModal {
  z-index: 999 !important;
}

.validation-wrapper {
  padding: 20px;
  width: 100%;
  box-sizing: border-box;
}

.title {
  margin: 0;
  padding-bottom: 10px;
  text-align: left;
  font-size: 1.3rem;
  font-weight: 600;
}

.validation-list {
  list-style: none;
  margin: 0;
  padding: 0;

  max-height: 300px;
  overflow-y: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  padding: 10px;

  li {
    display: flex;
    align-items: center;
    font-size: 0.95rem;
    padding: 6px 0;
    border-bottom: 1px solid #f0f0f0;

    &:last-of-type {
      border-bottom: none;
    }
  }
}

.warning-icon {
  color: #dc143d;
  margin-right: 8px;
  font-size: 1rem;
}

.no-validations {
  padding: 20px;
  text-align: center;
  font-style: italic;
  color: #777;
}

.button-row {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}

.button {
  min-width: 120px;
  padding: 6px 15px;
  margin-left: 5px;
}

.ghost {
  background-color: white;
  box-shadow: none;
  color: #dc143d;
  border: 1px solid #dc143d;

  &:hover {
    color: #212146;
    border-color: #212146;
  }
}
</style>